export default __webpack_public_path__ + "locales/sq-AL/UploadPanel.json?hash=29fe0d40d1ad36cc0b6683a85f04a87b";